import { create } from 'zustand';

interface StoreState {
  isNameInputShow: boolean;
  setIsNameInputShow: (isInputShow: boolean) => void;
}

export const useNameChangeInputShow = create<StoreState>((set, get) => {
  return {
    isNameInputShow: false,
    setIsNameInputShow: (isNameInputShow: boolean) => {
      set({ isNameInputShow });
    },
  };
});
